import axios from "axios";
import coinMapper from "@/services/coinMapperFunc";
import Options from "@/options";

function findCoin(coins, findParams) {
  let index = coins.findIndex((coin) => {
    return findParams.currencyId && coin.id === findParams.currencyId;
  });
  index =
    index > -1
      ? index
      : coins.findIndex((coin) => {
          return (
            coin.symbol === findParams.currency ||
            coin.symbol === findParams.symbol
          );
        });
  if (findParams.returnIndex) {
    return index;
  }
  return index > -1 ? coins[index] : null;
}

export default {
  namespaced: true,
  state: {
    hasError: false,
    requestInProcess: false,
    coinMarketCapData: [],
    lastUpdated: null,
    interval: null,
  },
  getters: {
    ifHasError: (state) => state.hasError,
    isReady: (state) => state.coinMarketCapData.length > 0,
    requestInProcess: (state) => state.requestInProcess,
    lastUpdated: (state) => state.lastUpdated,
    priceOfBTC: (_state, getters) => {
      const btc = getters.coins.find((coin) => coin.symbol === "BTC");
      return btc ? btc["price_usd"] : 0;
    },
    interval: (state) => state.interval,
    coins(state) {
      return state.coinMarketCapData.map(coinMapper);
    },
    coinByFindParams: (_state, getters) => (findParams) => {
      return findCoin(getters.coins, findParams);
    },
  },
  mutations: {
    setHasError(state, value) {
      state.hasError = value;
    },
    setRequestInProcess(state, status) {
      state.requestInProcess = status;
    },
    setCoinMarketCapData(state, data) {
      state.coinMarketCapData = data;
    },
    setLastUpdated(state, time) {
      state.lastUpdated = time;
    },
    setIntervalValue(state, interval) {
      state.interval = interval;
    },
  },
  actions: {
    startCoinMarketCapInterval(
      { state, commit, dispatch },
      intervalTimeout = 0
    ) {
      if (state.interval) {
        return;
      }
      const getData = () => {
        dispatch("getCoinMarketCapData");
      };
      const interval = setInterval(
        getData,
        intervalTimeout || Options.coinmarketcapIntervalTimeout
      );
      commit("setIntervalValue", interval);
    },
    stopCoinMarketCapInterval({ state, commit }) {
      clearInterval(state.interval);
      commit("setIntervalValue", null);
    },
    addCoin({ state, commit }, coin) {
      const coins = [...state.coinMarketCapData].concat([coin]);
      commit("setCoinMarketCapData", coins);
    },
    refetchCoinsIfHasChanges: ({ state, dispatch }, { assetsNew }) => {
      const coinsOldStr = state.coinMarketCapData
        .filter((v) => v.id !== 'bitcoin')
        .map((v) => v.id)
        .sort()
        .join();
      const newStr = assetsNew
        .filter((v) => v.currencyId !== 'bitcoin')
        .map((v) => v.currencyId)
        .sort()
        .join();
      if (coinsOldStr !== newStr) {
        dispatch("getCoinMarketCapData");
      }
    },
    async getCoinMarketCapData({ state, commit, dispatch, rootGetters }) {
      const hadError = state.hasError;
      let hasError = false;
      try {
        commit("setRequestInProcess", true);
        let assetsIdsStr = rootGetters["portfolio/assets"]
          .filter((v) => v.currencyId || v.currency)
          .map((v) => (v.currencyId || v.currency).trim())
          .join();
        const profitlossAssetsIdsStr = rootGetters["profitloss/assetsIds"].join();
        if (profitlossAssetsIdsStr) {
          assetsIdsStr += "," + profitlossAssetsIdsStr;
        }
        let url = Options.coinmarketcapListUrl;
        if (assetsIdsStr) {
          url += (url.indexOf("?") > -1 ? "&" : "?") + "ids=" + assetsIdsStr;
        }
        const response = await axios.get(url);
        hasError = response.data.hasError;
        commit("setCoinMarketCapData", response.data.values);
        commit("setLastUpdated", new Date());
      } catch (err) {
        console.error("getCoinMarketCapData", err);
        hasError = true;
        // TODO: notification about the problem?
        // TODO: include raven error here? lots of traffic from this
      } finally {
        commit("setRequestInProcess", false);
      }
      commit("setHasError", hasError);

      if (hadError && !hasError) {
        dispatch("stopCoinMarketCapInterval");
        dispatch("startCoinMarketCapInterval");
      }
      if (!hadError && hasError) {
        dispatch("stopCoinMarketCapInterval");
        dispatch(
          "startCoinMarketCapInterval",
          Options.coinmarketcapIntervalTimeout_afterError
        );
      }
    },
    async getCoinMarketCapDataByQuery({ state, commit }, query) {
      let hasError = false;
      let values = [];

      if (!state.requestInProcess) {
        try {
          commit("setRequestInProcess", true);
          let url = Options.coinmarketcapListUrl;
          url += (url.indexOf("?") > -1 ? "&" : "?") + "query=" + query;
          const response = await axios.get(url);
          ({ hasError, values } = response.data);
        } catch (err) {
          console.error("getCoinMarketCapDataByQuery", err);
          hasError = true;
        } finally {
          commit("setRequestInProcess", false);
        }
        commit("setHasError", hasError);
      }

      return values;
    },
  },
};
